<template>
    <div class="auth-form">
        <div class="auth-form--form">
            <h3>
                <h3 v-html="headline"></h3>
            </h3>
            <form @submit.prevent="submit">
                <card class="card--minify card--message error " v-if="form.errors.account">
                    <card-content v-html="form.errors.account"></card-content>
                </card>

                <form-input type="email" id="email" :label="this.$gettext('Email Adresse')" v-model="form.email"
                            placeholder="john@doe.com" :error="form.errors.email" icon="email-mail-checkmark"
                            autocomplete="email" autofocus/>
                <form-password type="password" id="password" :label="this.$gettext('Passwort')" v-model="form.password"
                               :error="form.errors.password"/>
                <form-checkbox id="remember" :option="this.$gettext('angemeldet bleiben')"
                               v-model:checked="form.remember"/>

                <div class="form-actions">
                    <Link :href="$$route(registerRoute)">
                        <translate>Sie haben noch keinen Account?</translate>
                    </Link>
                    <form-button type="submit" color="secondary" icon="lock-shield-prote" :disabled="form.processing"
                                 :class="{'btn--processing': form.processing}">
                        <translate>Login</translate>
                    </form-button>
                </div>
            </form>
        </div>
        <div class="auth-form--info">
            <p class="body-2 body-2--disabled">
                <translate render-html="true">Es können ausschließlich <strong>registrierte Geschäftskunden</strong>
                    beliefert werden.
                    An Privatpersonen liefern wir nicht aus! Ihre Daten werden nur für Ihre Anfragen und Aufträge
                    genutzt, nicht an Dritte weitergeleitet, nicht für Werbezwecke verwendet. Das garantieren wir Ihnen.
                    Ihre Kundendaten handhaben wir streng vertraulich, gemäß den Datenschutzbestimmungen der
                    Bundesrepublik Deutschland.
                </translate>
            </p>
        </div>
    </div>
</template>
<script>
import CardContent from '@partfactory/Shared/Card/CardContent.vue';
import FormInput from '@partfactory/Shared/Form/FormInput.vue';
import FormButton from '@partfactory/Shared/Form/FormButton.vue';
import Card from '@partfactory/Shared/Card/Card.vue';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox.vue';
import FormPassword from '@partfactory/Shared/Form/FormPassword.vue';
import {useForm} from '@inertiajs/vue3';

export default {
    name: 'AuthFormLogin',
    components: {FormPassword, FormCheckbox, Card, FormButton, FormInput, CardContent},
    props: {
        headline: String,
        route: String,
        registerRoute: String,
        credentials: Object,
    },
    created() {
        console.log(this.credentials);
        this.form.email = this.credentials?.email;
    },
    setup() {
        const form = useForm({
            email: null,
            password: null,
            remember: false,
        });

        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    remember: this.form.remember ? 'true' : '',
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route(this.route), {
                    onError: () => this.form.reset('password'),
                    onSuccess: () => {
                        this.form.reset('password');
                    }
                });
        },
    },
};
</script>
